__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "trade-components";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "4.8.3", () => (Promise.all([__webpack_require__.e(292), __webpack_require__.e(333)]).then(() => (() => (__webpack_require__(90333))))));
			register("@reduxjs/toolkit", "1.9.7", () => (__webpack_require__.e(7298).then(() => (() => (__webpack_require__(97298))))));
			register("antd", "4.24.16", () => (Promise.all([__webpack_require__.e(6178), __webpack_require__.e(292), __webpack_require__.e(7639), __webpack_require__.e(5748), __webpack_require__.e(9783)]).then(() => (() => (__webpack_require__(35748))))));
			register("axios-mock-adapter", "1.22.0", () => (Promise.all([__webpack_require__.e(875), __webpack_require__.e(9128)]).then(() => (() => (__webpack_require__(99128))))));
			register("axios", "0.24.0", () => (__webpack_require__.e(854).then(() => (() => (__webpack_require__(40854))))));
			register("dayjs", "1.11.13", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(60446))))));
			register("echarts-for-react", "3.0.2", () => (Promise.all([__webpack_require__.e(1451), __webpack_require__.e(8545)]).then(() => (() => (__webpack_require__(1451))))));
			register("echarts", "5.5.1", () => (__webpack_require__.e(1126).then(() => (() => (__webpack_require__(31126))))));
			register("i18next", "20.6.1", () => (__webpack_require__.e(345).then(() => (() => (__webpack_require__(80345))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(97950))), 1);
			register("react-helmet-async", "1.3.0", () => (__webpack_require__.e(9490).then(() => (() => (__webpack_require__(29490))))));
			register("react-i18next", "11.18.6", () => (__webpack_require__.e(1903).then(() => (() => (__webpack_require__(41903))))));
			register("react-infinite-scroll-component", "6.1.0", () => (__webpack_require__.e(4997).then(() => (() => (__webpack_require__(64997))))));
			register("react-lazyload", "3.2.1", () => (__webpack_require__.e(6876).then(() => (() => (__webpack_require__(16876))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(7508), __webpack_require__.e(9783)]).then(() => (() => (__webpack_require__(97508))))));
			register("react-responsive", "9.0.2", () => (__webpack_require__.e(5237).then(() => (() => (__webpack_require__(95237))))));
			register("react-router-dom", "6.27.0", () => (Promise.all([__webpack_require__.e(3245), __webpack_require__.e(9783)]).then(() => (() => (__webpack_require__(53245))))));
			register("react-slick", "0.28.1", () => (Promise.all([__webpack_require__.e(7639), __webpack_require__.e(2382)]).then(() => (() => (__webpack_require__(92382))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(65043))), 1);
			register("styled-components", "5.3.11", () => (__webpack_require__.e(4574).then(() => (() => (__webpack_require__(94574))))));
			register("typeface-lato", "1.1.13", () => (__webpack_require__.e(4150).then(() => (() => (__webpack_require__(4150))))));
			register("typeface-montserrat", "1.1.13", () => (__webpack_require__.e(7845).then(() => (() => (__webpack_require__(77845))))));
			register("web-vitals", "1.1.2", () => (__webpack_require__.e(6453).then(() => (() => (__webpack_require__(46453))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};